import React from 'react';
import * as FiIcons from 'react-icons/fi';
import * as BiIcons from 'react-icons/bi';
import * as MdIcons from 'react-icons/md';
import { FiAlertTriangle } from 'react-icons/fi';

const SafeIcon = ({ icon, className, ...props }) => {
  // If icon is a component function
  if (typeof icon === 'function') {
    return React.createElement(icon, { className, ...props });
  }
  
  return <FiAlertTriangle className={className} {...props} />;
};

export default SafeIcon;